const basePath = '/brokerage';

export const brokerageRoutePaths = {
  root: basePath,
  orders: `${basePath}/orders`,
  orderDetail: `${basePath}/orders/:id`,
  quotes: `${basePath}/quotes`,
  quoteDetail: `${basePath}/quotes/:id`,
  loads: `${basePath}/loads`,
  loadDetail: `${basePath}/loads/:id`,
} as const;
